module.exports = __webpack_public_path__ + "img/mail_b2.a164691d.svg";